// react
import React, { useState, useEffect } from "react";

// third-party
import { Link } from "react-router-dom";
import { getNoImg, url, returnResponsiveImg, useWindowSize, allEqual, renderComboDealsCondition, checkHvStock } from "../../services/utils";
import Currency from "../shared/Currency";

function BlockProductComboDeals(props) {
    const { product, eventData, history, noTitle } = props;
    const [comboDeals, setComboDeals] = useState([]);
    const [addCartLoading, setAddCartLoading] = useState(false);
    const windowSize = useWindowSize();

    useEffect(() => {
        if (eventData?.event_info && product) {
            let addOnList = eventData?.event_info?.joined_product_json.filter(
                (item) => item.status?.code == 10 && checkHvStock(item) && (item.progression == "ongoing" || item.progression == null)
            );
            if (addOnList) {
                setComboDeals(addOnList.filter((item) => item.uuid !== product.uuid));
            }
        }
    }, [eventData, product]);

    const returnResponsiveItemCount = () => {
        return windowSize.width < 576 ? 1 : windowSize.width < 768 ? 2 : windowSize.width < 992 ? 3 : 5;
    };

    const renderProduct = (prod) => {
        let price = (
            <div className="product-card__prices d-flex">
                {!prod.is_sales && allEqual(prod.price, "price") ? (
                    <Currency value={prod.price} />
                ) : prod.is_sales && allEqual(prod.sales_price, "price") ? (
                    <>
                        <div className="product__new-price">
                            <Currency value={prod.sales_price} />
                        </div>
                        {!allEqual([...prod.sales_price, ...prod.price], "price") ? (
                            <div className="product__old-price" style={{ fontSize: "inherit" }}>
                                <Currency value={prod.price} />
                            </div>
                        ) : null}
                    </>
                ) : prod.is_sales ? (
                    <>
                        <Currency value={prod.sales_price[0]} /> {prod.sales_price[prod.sales_price.length - 1] ? " - " : null}{" "}
                        {prod.sales_price[prod.sales_price.length - 1] ? (
                            <Currency value={prod.sales_price[prod.sales_price.length - 1]} />
                        ) : null}
                    </>
                ) : (
                    <>
                        <Currency value={prod.price[0]} /> {prod.price[prod.price.length - 1] ? " - " : null}{" "}
                        {prod.price[prod.price.length - 1] ? <Currency value={prod.price[prod.price.length - 1]} /> : null}
                    </>
                )}
            </div>
        );

        return (
            <div key={prod.slug} className="product-bundle-card">
                <div className="product-card__image product-image">
                    <Link to={url.product(prod)} className="product-image__body">
                        <img
                            className="product-image__img"
                            src={prod.images && prod.images[0] ? returnResponsiveImg(prod.images[0]) : getNoImg()}
                            alt=""
                            onError={(e) => (e.target.src = getNoImg())}
                        />
                        {prod.qty > 1 ? <span className="right-bottom-qty">{prod.qty}</span> : null}
                    </Link>
                </div>
                <div className="product-bundle-card__info">
                    <div className={"product-card__name"}>
                        <Link to={url.product(prod)}>{prod.name}</Link>
                    </div>
                    {price}
                </div>
            </div>
        );
    };

    return comboDeals?.length > 0 ? (
        <div className="bundle-deals-section">
            <div className="combo-section">
                <div className="section-title pb-0">
                    <div className="d-flex flex-wrap">
                        <div className="mr-2" style={noTitle ? { visibility: "hidden" } : {}}>
                            Combo Deals
                        </div>
                        <label className="combo-label">{renderComboDealsCondition(eventData?.event_info?.condition_json[0])}</label>
                    </div>

                    <Link to={{ pathname: url.comboDeals(comboDeals[0]) }} className="more">
                        See All <i className="fas fa-chevron-right" />
                    </Link>
                </div>
                <hr />
                <div className="product-bundle-list">
                    {comboDeals[0] &&
                        comboDeals?.slice(0, returnResponsiveItemCount() + 1).map((item, index) => {
                            return renderProduct(item);
                        })}
                </div>
            </div>
        </div>
    ) : null;
}

export default BlockProductComboDeals;
